module.exports = __webpack_public_path__ + "8f653d052a9b06da3c5028467d6580cd.png";